import { Box, Flex, Text, Image } from "@mantine/core";
import { useTranslation } from "react-i18next";
import { useMediaQuery } from "@mantine/hooks";
import "./BrochureContactHeader.scss";
import IconPhone from "../../assets/images/Phone.svg";


export const BrochureContactHeader = () => {
  const { t } = useTranslation();
  const isMobile = useMediaQuery("(max-width: 1415px)", true, {
    getInitialValueInEffect: false,
  });

  return !isMobile ? (
    <Box p="md" className="brochureContactHeader" h={40}>
        <Flex gap={8} h="100%" align={"center"} justify="flex-end" w="85%">
            <Text ff="Montserrat" c="white">{t("roadside-assistance")}:</Text>
            <Image
                src={IconPhone}
                style={{ width: "20px", height: "20px", marginTop: -2 }}
            />
            <Text ff="Montserrat" c="white" tt={"uppercase"}>{t("roadside-assistance-phone-number")}</Text>
        </Flex>
    </Box>
  ) : null;
};
